import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./ContactPage.module.css";

function ContactUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      q: "Q: What makes your coffee shop unique?",
      a: "A: Dukamo Coffee is unique for its ethically sourced coffee, expertly roasted in-house and brewed using various methods, including jebena, V60, and espresso. Our coffee shops blend cultural and modern outlooks.",
    },
    {
      q: "Q: Why is your macchiato not as hot as other places?",
      a: "A: We are at standard on par with international speciality cafes. If the beverage is too hot to hold then its too hot for consumption. When milk is steamed abouve 65-70 degrees it rapidly begins to break down. However is you still prefer it hot, feel free to let our servers know in advance to make it so.",
    },
    {
      q: "Q: Do you have dairy-free or alternative milk options?",
      a: "A: Sorry! we currently don't have alternative milk options, but soon we will.",
    },
    {
      q: "Q: Can I buy your coffee beans?",
      a: "A: Absolutely! We sell freshly roasted coffee beans in different roasts types for home brewing.",
    },
    {
      q: "Q: Do you offer food or pastries?",
      a: "A: Yes! We have a selection of freshly baked pastries and snacks that pair perfectly with our coffee.",
    },
    {
      q: "Q: Can I work or have meetings at your café?",
      a: "A: Yes you can, but sometimes our shops get busy and it gets a bit hard to work/ study alone.",
    },
    {
      q: "Q: Do you take reservations?",
      a: "A: We operate on a first-come, first-served basis, but we accommodate group bookings for special occasions.",
    },
    {
      q: "Q: Do you offer catering services?",
      a: "A: No, we currently don't provide catering services.",
    },
    {
      q: "Q: Can I place a custom coffee order?",
      a: "A: Yes, we can roast to your specifications and provide custom grind sizes based on your brewing method.",
    },
    {
      q: "Q: How fresh is your roasted coffee?",
      a: "A: Our coffee is roasted in small batches to ensure maximum freshness and flavor.",
    },
    {
      q: "Q: Do you provide grind options for home brewing?",
      a: "A: Yes! We can grind your coffee for Jebena, espresso, V60, or any other method.",
    },
    {
      q: "Q: Do you export coffee?",
      a: "A: Yes, we export roasted beans around the world.",
    },
    {
      q: "Q: Do you offer cupping or barista classes?",
      a: "A: Currently we only offer our classes for internal employees. However we will soon open the classes for public.",
    },
  ];

  return (
    // Wrapper applies the Black Background
    <div className={styles.contactUsPage}>
      <Navbar />

      {/* HERO SECTION - White Banner (Original Style) */}
      <section className={styles.contactHero}>
        <h1>Locations</h1>
        <p className={styles.subtitle}>Mafi City Mall, Bole Addis Ababa</p>
        <p className={styles.subtitle}>
          Nile Insurance Bldg, Mexico Addis Ababa
        </p>
        <p className={styles.subtitle}>
          Daye Bensa Building, Sumuda Gebriel, Hawassa
        </p>
      </section>

      {/* CONTENT SECTIONS - Dark Luxury Theme */}
      <section className={styles.locationsGrid}>
        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.7357110587236!2d38.78506467408403!3d8.99644898949959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85c3db293851%3A0x32364873171cc589!2zRHVrYW1vIENvZmZlZSBCb2xlIHwg4Yux4Yqr4YieIOGJoeGKkw!5e0!3m2!1sen!2sus!4v1760968203435!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dukamo Mafi Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Mafi City Mall, Ground Floor</h3>
            <p>Addis Ababa</p>
            <p>Monday - Sunday 8:00AM - 9:00PM</p>
            <p>(+251)933443322</p>
          </div>
        </div>

        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5265126800514!2d38.74640957038252!3d9.015640369432525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8506348b950d%3A0x3a349993075fd9bd!2zRHVrYW1vIENvZmZlZSAoQmhlcmF3aSkgfCDhi7HhiqvhiJ4g4Ymh4YqTICjhiaXhiIThiKvhi4op!5e0!3m2!1sen!2sus!4v1760968274199!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dukamo Nile Insurance Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Nile Insurance Building, Ras Abebe Aregay St</h3>
            <p>Addis Ababa</p>
            <p>Monday - Sunday 8:00AM - 9:00PM</p>
          </div>
        </div>

        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3959.6749103317948!2d38.47566107406692!3d7.047434816855094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x17b14f88af946da3%3A0x8469fcd7f91176e4!2sDukamo%20Coffee%20(Hawassa)!5e0!3m2!1sen!2sus!4v1760968309312!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dukamo Hawassa Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Daye Bensa Building Ground Floor</h3>
            <p>Hawassa</p>
            <p>Monday - Sunday 8:00AM - 8:00PM</p>
            <p>(+251)919046565</p>
          </div>
        </div>
      </section>

      <section className={styles.otherEnquiries}>
        <div className={styles.enquiryBlock}>
          <h3>For Wholesale service</h3>
          <p>(+251)92-422-22-00</p>
        </div>
        <div className={styles.enquiryBlock}>
          <h3>For Export</h3>
          <p>(+251)91-098-5454 or (+251)94-007-5265</p>
        </div>
        <div className={styles.enquiryBlock}>
          <h3>For Other Enquiries</h3>
          <p>Job Search: (+251)94-007-5265</p>
          <p>Complaints: (+251)91-098-5454</p>
        </div>
      </section>

      <section className={styles.faqSection}>
        <h2>FAQ's from Customers</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.faqItem}>
              <p className={styles.faqQuestion}>{faq.q}</p>
              <p className={styles.faqAnswer}>{faq.a}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ContactUsPage;
